var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "RouterLink",
    {
      attrs: {
        to: {
          name: _vm.routes.PROJECT_ACTIVITY,
          params: { id: _vm.projectId },
        },
      },
    },
    [_c("Chip", { attrs: { chipContent: _vm.projectName } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }